/**
 * minicart-assembly-guard.js
 *
 * Hides the minicart checkout button whenever a standalone blade AND at least
 * one standalone rubber are both in the cart. In that state the customer must
 * visit the full /cart page to complete paddle assembly instructions before
 * they can proceed to checkout.
 *
 * "Standalone" means not flagged as a _combo_child line item property — combo
 * special children already have their assembly handled by the wizard.
 *
 * The guard re-evaluates after every minicart re-render (quantity changes,
 * item removals, new additions) via a MutationObserver on #minicart-form.
 */
(function () {
  'use strict';

  var RUBBER_TYPES = ['rubber', 'rubbers'];

  function isRubberType(t) {
    return RUBBER_TYPES.indexOf((t || '').toLowerCase().trim()) !== -1;
  }

  function isBladeType(t) {
    var tl = (t || '').toLowerCase().trim();
    return tl.indexOf('blade') !== -1 && tl.indexOf('combo') === -1;
  }

  function isComboChild(item) {
    var p = item.properties || {};
    if (Array.isArray(p)) {
      return p.some(function (x) { return x.name === '_combo_child' && x.value === 'true'; });
    }
    return p['_combo_child'] === 'true';
  }

  // Read a line item property from a cart item (handles both object and array formats).
  function getItemProp(item, key) {
    var p = item.properties || {};
    if (Array.isArray(p)) {
      var found = p.filter(function (x) { return x.name === key; })[0];
      return found ? (found.value || '') : '';
    }
    return p[key] || '';
  }

  // A slot is complete if the customer chose "No" assembly, or chose "Yes"
  // and saved at least one rubber side (FH or BH).
  function slotIsComplete(blade, slotIndex) {
    var choice = getItemProp(blade, 'P' + slotIndex + ' Assemble');
    if (choice === 'No')  return true;
    if (choice === 'Yes') return !!(getItemProp(blade, 'P' + slotIndex + ' FH') || getItemProp(blade, 'P' + slotIndex + ' BH'));
    return false; // no choice saved yet
  }

  function bladeHasIncompleteSlot(blade) {
    var qty = parseInt(blade.quantity, 10) || 1;
    for (var s = 1; s <= qty; s++) {
      if (!slotIsComplete(blade, s)) return true;
    }
    return false;
  }

  function cartNeedsGuard(cart) {
    var items = cart.items || [];
    var blades  = items.filter(function (i) { return isBladeType(i.product_type)  && !isComboChild(i); });
    var hasRubber = items.some(function (i) { return isRubberType(i.product_type) && !isComboChild(i); });
    // Only block if there are rubbers AND at least one blade has an incomplete assembly slot.
    if (!hasRubber || !blades.length) return false;
    return blades.some(function (blade) { return bladeHasIncompleteSlot(blade); });
  }

  function applyGuard(needsGuard) {
    var checkoutBtn = document.querySelector('#minicart-form .btn-checkout');
    if (!checkoutBtn) return;

    var notice = document.getElementById('cw-minicart-guard-notice');

    if (needsGuard) {
      checkoutBtn.style.display = 'none';
      if (!notice) {
        notice = document.createElement('p');
        notice.id = 'cw-minicart-guard-notice';
        notice.style.cssText = [
          'font-size:0.78rem',
          'text-align:center',
          'color:#666',
          'margin:8px 0 0',
          'line-height:1.45',
          'padding:0 4px'
        ].join(';');
        notice.textContent = 'View your cart to set paddle assembly instructions before checking out.';
        checkoutBtn.parentNode.insertBefore(notice, checkoutBtn.nextSibling);
      }
      notice.style.display = '';
    } else {
      checkoutBtn.style.display = '';
      if (notice) notice.style.display = 'none';
    }
  }

  var _guardTimer = null;
  function runGuard() {
    clearTimeout(_guardTimer);
    _guardTimer = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { applyGuard(cartNeedsGuard(cart)); })
        .catch(function (e) { console.warn('[MiniCartGuard]', e); });
    }, 50);
  }

  function init() {
    var form = document.getElementById('minicart-form');
    if (!form) return;

    runGuard();

    // Re-evaluate whenever the minicart section HTML is swapped in (cart updates,
    // qty changes, removals). Observing direct children only (subtree:false) so
    // that our own DOM changes (inserting the notice) do not re-trigger the observer.
    new MutationObserver(function () {
      runGuard();
    }).observe(form, { childList: true, subtree: false });
  }

  document.addEventListener('DOMContentLoaded', init);

})();
